/* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
import Location from '@solvhealth/types/interfaces/Location';
import { isExternalTelemedBooking } from '../../../core/util/booking';
import { isEmptyObject, safeGet } from '../../../core/util/object';
import { BASE_URL } from '../../../config/index';
import { buildStreetViewUrl } from '../../../core/google/staticmap';
import { isTabletOrSmaller } from '../../../core/util/device/screen';
import { isTelemedLocation } from '../../../core/util/location';
const MOBILE_MAX_VIEW_WIDTH = 480;

const getWidth = (viewport: any) => {
  if (!viewport) return MOBILE_MAX_VIEW_WIDTH;
  if (isTabletOrSmaller(viewport.width)) {
    if (viewport.width > MOBILE_MAX_VIEW_WIDTH) {
      return MOBILE_MAX_VIEW_WIDTH;
    }

    return viewport.width;
  }

  return 537;
};

const getHeight = (viewport: any) => {
  if (!viewport) return 200;
  return isTabletOrSmaller(viewport.width) ? 200 : 308;
};

export const LOGO = 'logo';
export const PHOTO = 'photo';

export const THUMBNAIL_SMALL = 'small'; // 128x128
export const THUMBNAIL_MEDIUM = 'medium'; //200x200

const DEFAULT_IMAGE = `${BASE_URL}/images/Default-Clinic-Photo.svg`;
const TELEMED_IMAGE = `${BASE_URL}/images/telemed/Graphic-telemed.svg`;
const STREET_VIEW_URL = 'https://maps.googleapis.com/maps/api/streetview';

const getImageObject = (
  location: Location,
  { imageIndex, imageType, showDefaultPictureIfMissing, booking }: any = {}
) => {
  if (!location || isEmptyObject(location) || isEmptyObject(location.imageLinks)) return {};

  const {
    imageLinks,
    // eslint-disable-next-line camelcase
    imageLinks: { logo, logo_webp, logo_jp2 },
  } = location;

  const safeImageLinks = safeGet(imageLinks);

  let imageObject = {};

  if (imageType === LOGO) {
    const fullResLogo = safeGet(logo, DEFAULT_IMAGE)('0');

    imageObject = {
      fullRes: fullResLogo,
      webp: safeGet(logo_webp, fullResLogo)('0'),
      jp2: safeGet(logo_jp2, fullResLogo)('0'),
    };
  } else if (isTelemedLocation(location) || (booking && isExternalTelemedBooking(booking))) {
    return { fullRes: TELEMED_IMAGE };
  } else {
    let fullRes = safeGet(
      imageLinks,

      showDefaultPictureIfMissing ? DEFAULT_IMAGE : null
    )(`image.${imageIndex}`);
    let webp = safeImageLinks(`image_webp.${imageIndex}`);
    let jp2 = safeImageLinks(`image_jp2.${imageIndex}`);
    let thumbnail128 = safeImageLinks(`image_128x128_thumbnail.${imageIndex}`);
    let thumbnail200 = safeImageLinks(`image_200x200_thumbnail.${imageIndex}`);

    if (fullRes && fullRes.includes(STREET_VIEW_URL)) {
      // replacing the google maps street view photo with default photo
      fullRes = '/images/Default-Clinic-Photo.svg';
      webp = '/images/Default-Clinic-Photo.svg';
      jp2 = '/images/Default-Clinic-Photo.svg';
      thumbnail128 = '/images/Default-Clinic-Photo.svg';
      thumbnail200 = '/images/Default-Clinic-Photo.svg';
    }

    imageObject = { fullRes, webp, jp2, thumbnail128, thumbnail200 };
  }

  return imageObject;
};

const getLogoImageObject = (location: any) => getImageObject(location, { imageType: LOGO });

export { getImageObject, getLogoImageObject };
